module.exports = __webpack_public_path__ + "img/Milestone-Light-Yellow.738398ab.svg";